import { useEffect, useState } from "react";
import React from "react";
import "../Assets/Css/Teachers.css";
import prevArrow from "../Assets/Images/Dashboard/prev_icon.png";
import nextArrow from "../Assets/Images/Dashboard/next_icon.png";
import { styled } from "@mui/material/styles";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import upArrow from "../Assets/Images/Dashboard/up_arrow.png";
import downArrow from "../Assets/Images/Dashboard/down_arrow.png";
import profile_pic from "../Assets/Images/Dashboard/default_profile.svg";
import school_image from "../Assets/Images/Dashboard/schoolDummyLogo.png";
import Sidebar from "../Component/Sidebar";
import Loader from "../Component/Loader";
import { Link } from "react-router-dom";
import { TEACHER_LIST_GET_API, API_START_POINT, DIET_LIST_GET_API } from "../Component/AllApi";
import ExportToExcel from "../Component/ExportToExcel";

const Diet = () => {
  const Android12Switch = styled(Switch)(({ theme }) => ({
    padding: 8,
    "& .MuiSwitch-track": {
      borderRadius: 22 / 2,
      backgroundColor: theme.palette.mode === "dark" ? "#63D92C" : "#7C0D0D",
    },
    "& .MuiSwitch-thumb": {
      boxShadow: "none",
      width: 16,
      height: 16,
      margin: 2,
      backgroundColor: "#fff",
    },
  }));

  const itemsPerPage = 10;

  const [user, setUser] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [sortKey, setSortKey] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const [toggleStates, setToggleStates] = useState(
    // false || new Array(itemsPerPage).fill(false)
    []
  );

  //State for Form
  const [newDiet, setNewDiet] = useState({
    name: "",
    phone: "",
    email: "",
    DistrictID: "",
  });
  const [districts, setDistricts] = useState([]);
  const [errors, setErrors] = useState({});

  //Fetching District
  useEffect(() => {
    const fetchSchoolList = async () => {
      var token = localStorage.getItem("authToken");
      try {
        const response = await fetch("SCHOOL_LIST_GET_API", {
          method: "GET",
          headers: {
            Authorization: `bearer ${token}`,
          },
        });
        if (!response.ok) throw new Error("Failed to fetch school list");
        const data = await response.json();

        setDistricts(data);
        // console.log(data.allSchools);
      } catch (error) {
        console.error("Error fetching school list:", error);
      }
    };
    fetchSchoolList();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      // console.log('data is fetching...');
      var token = localStorage.getItem("authToken");
      try {
        const response = await fetch(DIET_LIST_GET_API, {
          method: "GET",
          headers: {
            Authorization: `bearer ${token}`,
          },
        });
        if (!response.ok) {
          throw new Error("Something went wrong");
        }
        const { allDiets } = await response.json();
        // console.log("Diet data: ", allDiets);
        setUser(allDiets);
        // console.log('data is fetched');
        const initialToggleState = allDiets.map(
          (trainer) => trainer.diet_is_active === 1
        );
        setToggleStates(initialToggleState);
      } catch (error) {
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  //Form Data Change handler
  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewDiet((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  //Validating Form
  const validateForm = () => {
    const newErrors = {};

    // Name validation
    if (!newDiet.name) {
      newErrors.name = "Name is required";
    }

    // Phone validation (example: should be 10 digits)
    if (!/^\d{10}$/.test(newDiet.phone)) {
      newErrors.phone = "Enter a valid 10-digit phone number";
    }

    // Email validation
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;
    if (!emailPattern.test(newDiet.email)) {
      newErrors.email = "Enter a valid email address";
    }

    // School name validation
    // if (!newPrincipal.schoolName) {
    //   newErrors.schoolName = "Please select a school";
    // }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  //Submitting form
  const handleFormSubmit = async (e) => {
    const token = localStorage.getItem("authToken");
    e.preventDefault();
    if (validateForm()) {
      // console.log(newDiet);

      // Transform `newPrincipal` to the required API format
      const formattedData = {
        diet_name: newDiet.name,
        diet_email: newDiet.email,
        diet_mobile: newDiet.phone,
        // diet_school: newDiet.schoolIds?.[0],
      };

      // console.log("Formatted Data for API:", formattedData);
      try {
        // Post newPrincipal data to your API to add a principal
        const response = await fetch("CREATE_PRINCIPAL_API", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `bearer ${token}`,
          },
          body: JSON.stringify(formattedData),
        });
        if (!response.ok) throw new Error("Failed to add principal");

        // alert("Principal added successfully!");

        setNewDiet({ name: "", phone: "", email: "", schoolIds: "" });
        // Optionally, fetch updated list
      } catch (error) {
        console.error("Error adding principal:", error);
      }
    }
  };

  //Cancel button handler
  const handleCancel = () => {
    setNewDiet({ name: "", phone: "", email: "", schoolIds: "" });
    setErrors({});
  };

  let count = 0;
  toggleStates.map((data) => {
    if (data == false) {
      count++;
    }
  });

  // localStorage.setItem("teacherCount", count);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const handleSort = (key) => {
    if (sortKey === key) {
      // If already sorted by this key, toggle the order
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      // If sorting by a new key, set it and default to ascending order
      setSortKey(key);
      setSortOrder("asc");
    }
  };
  const selectedSection = localStorage.getItem("selectedSection");

  const handleToggle = async (index, trainerID) => {
    // console.log(
    //   "handleToggle called with index:",
    //   index,
    //   "and trainerID:",
    //   trainerID
    // );
    // const TOGGLE_ACTIVE_API =
    //   selectedSection === "Robotics"
    //     ? `https://himachal.phntechnology.com/himachal/api/trainers/${trainerID}/toggle-active`
    //     : `https://himachal.phntechnology.com/himachal/api/drone-trainers/${trainerID}/toggle-active`;
    var token = localStorage.getItem("authToken");
    try {
      const newToggleStates = [...toggleStates];
      newToggleStates[index] = !newToggleStates[index];
      setToggleStates(newToggleStates);

      const response = await fetch(
        `${API_START_POINT}/trainers/${trainerID}/toggle-active`,
        {
          method: "PUT",
          headers: {
            Authorization: `bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            diet_is_active: newToggleStates[index] ? 1 : 0,
          }),
        }
      );
      // console.log("toggle", response);
      // console.log("tra active", newToggleStates[index]);
      if (!response.ok) {
        throw new Error("Failed to Update");
      }
      // console.log("Toggle state updated for trainer ID", trainerID);
    } catch (err) {
      console.error("Error occured", err);
    }
  };

  const filteredUsers = user.filter((userData) => {
    const query = searchQuery.toLowerCase();
    return (
      (userData.diet_name && userData.diet_name.toLowerCase().includes(query)) 
      ||
      (userData.district_name &&
        userData.district_name.toLowerCase().includes(query)) ||
      (userData.diet_email &&
        userData.diet_email.toLowerCase().includes(query)) ||
      (userData.diet_mobile && userData.diet_mobile.includes(query))
    );
  });

  const sortedUsers = sortKey
    ? filteredUsers.slice(indexOfFirstItem, indexOfLastItem).sort((a, b) => {
        // Sort function based on the current sort key and order
        const aValue = String(a[sortKey]).toLowerCase();
        const bValue = String(b[sortKey]).toLowerCase();
        if (aValue < bValue) return sortOrder === "asc" ? -1 : 1;
        if (aValue > bValue) return sortOrder === "asc" ? 1 : -1;
        return 0;
      })
    : filteredUsers.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);

  const totalItems = filteredUsers.length;
  const PagePerItem = Math.min(totalItems - indexOfFirstItem, indexOfLastItem);
  const rangeStart = Math.min((currentPage - 1) * itemsPerPage + 1, totalItems);
  const rangeEnd = Math.min(currentPage * itemsPerPage, totalItems);

  return (
    <>
      <Sidebar />
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <section className="schoolListSection">
            <div className="sidebody">
              <div className="container">
                {/* Your main_div */}
                <div className="main_div">
                  <div
                    className="schListHeader_div"
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    {/* Your header_text and search_div */}
                    <div className="schListHeader_text">
                      <p>DIET</p>
                    </div>
                    <div className="d-flex">
                    <div>
                        <ExportToExcel
                          data={user}
                          fileName="Diet_list"
                          sheetName="Diets"
                          columns={[
                            { key: "diet_name", alias: "DIET Name" },
                            { key: "diet_mobile", alias: "Mobile Number" },
                            { key: "diet_email", alias: "Email" },
                            { key: "district_name", alias: "Location" },
                          ]}
                        />
                      </div>
                      <div className="searchBar">
                        <form className="d-flex">
                          <input
                            className="form-control me-2"
                            type="search"
                            placeholder="Search"
                            aria-label="Search"
                            onChange={handleSearch}
                            style={{ borderRadius: "12px", border: "none" }}
                          />
                        </form>
                      </div>
                    </div>
                  </div>
                  {/* Your content table-responsive */}
                  {sortedUsers?.length < 0 || sortedUsers?.length == 0 ? (
                    <>
                      <p className="progressMainTitle text-center">
                        No data available
                      </p>
                    </>
                  ) : (
                    <div className="card schoolListTableDiv" style={{ border: "none" }}>
                      <div
                        className=" table-responsive  card-body"
                        style={{ maxHeight: "750px",width:"auto" }}
                      >
                        <table className="table table-borderless">
                          <thead
                            style={{ marginBottom: "20px" }}
                            className="thead_div"
                          >
                            <tr>
                              <th
                                style={{ width: "8%" }}
                                className="thead_div_row pb-4"
                              >
                                Sr. No
                              </th>
                              <th
                                scope="col"
                                // style={{ width: "20%", textAlign: "left" }}
                                className="thead_div_row pb-4"
                              >
                                Diet &nbsp;
                                <button
                                  className="sort_button"
                                  onClick={() => handleSort("diet_name")}
                                  // style={{marginLeft:"4px"}}
                                >
                                  <img
                                    src={
                                      sortKey === "diet_name" &&
                                      sortOrder === "asc"
                                        ? downArrow
                                        : upArrow
                                    }
                                    className="desc"
                                    style={{ marginRight: "15px" }}
                                    alt="arrows"
                                  />
                                </button>
                              </th>
                              <th
                                scope="col"
                                className="thead_div_row pb-4"
                                // style={{ width: "20%" }}
                              >
                                Email Id&nbsp;
                                <button
                                  className="sort_button"
                                  onClick={() => handleSort("diet_email")}
                                >
                                  {" "}
                                  <img
                                    src={
                                      sortKey === "diet_email" &&
                                      sortOrder === "asc"
                                        ? downArrow
                                        : upArrow
                                    }
                                    className="desc"
                                    style={{ marginRight: "15px" }}
                                    alt="arrows"
                                  />
                                </button>{" "}
                              </th>
                              <th
                                scope="col"
                                className="thead_div_row pb-4"
                                // style={{ width: "15%" }}
                              >
                                Location{" "}
                                <button
                                  className="sort_button"
                                  onClick={() => handleSort("district_name")}
                                >
                                  {" "}
                                  <img
                                    src={
                                      sortKey === "district_name" &&
                                      sortOrder === "asc"
                                        ? downArrow
                                        : upArrow
                                    }
                                    className="desc"
                                    // style={{ marginRight: "15px" }}
                                    alt="arrows"
                                  />
                                </button>{" "}
                              </th>
                              {/* <th
                                scope="col"
                                className="thead_div_row pb-4"
                                style={{ width: "15%" }}
                              >
                                Mobile Number
                              </th> */}
                              {/* <th
                                scope="col"
                                className="thead_div_row pb-4 ps-4"
                              >
                                Authorization (Active User)
                              </th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {sortedUsers.map((userData, index) => (
                              <tr key={index}>
                                <td
                                  className="header_srNo"
                                  style={{ paddingBottom: "36px" }}
                                >
                                  {index + indexOfFirstItem + 1}
                                </td>
                                <td className="d-flex">
                                {/* <span className="allocatedTeacher ms-2">
                                      {userData.diet_name}
                                    </span> */}
                                  <Link
                                    to="/dietParticularData"
                                    style={{ textDecoration: "none" }}
                                    onClick={() => {
                                      localStorage.setItem(
                                        "diet_id",
                                        userData.diet_user_id
                                      );
                                      // localStorage.setItem(
                                      //   "diet_name",
                                      //   userData.diet_name
                                      // );
                                    }}
                                    state={{ dietId: userData.diet_user_id,dietName:userData.diet_name,dietLoc:userData.district_name }}
                                  >
                                    {/* <img
                                      src={
                                        userData.diet_image === null ||
                                        userData.diet_image === ""
                                          ? profile_pic
                                          : userData.diet_image
                                      }
                                      style={{
                                        width: "24px",
                                        height: "24px",
                                      }}
                                      onError={(e) => {
                                        e.target.src = profile_pic;
                                      }}
                                      alt="profilePic"
                                    /> */}

                                    <span className="allocatedTeacher ms-2" style={{cursor:"pointer"}}>
                                      {userData.diet_name}
                                    </span>
                                  </Link>
                                  {/* {toggleStates[index + indexOfFirstItem] ===
                                    false && (
                                    <span className="new_mark ms-2">New</span>
                                  )} */}
                                </td>
                                <td className="schoolname_text">
                                  <div className="d-flex">
                                    {/* <img
                                      src={school_image}
                                      style={{
                                        width: "24px",
                                        height: "24px",
                                        marginRight: "13px",
                                      }}
                                      alt="schoolImg"
                                    /> */}
                                    {userData.diet_email}
                                  </div>
                                </td>
                                <td className="location_text">
                                  {userData.district_name}
                                </td>
                                {/* <td className="teacher_mobile">
                                  {userData.diet_mobile}
                                </td> */}
                                {/* <td>
                                  <div className="row">
                                    {
                                      <div className="col-5 first_status">
                                        <p
                                          style={{
                                            fontWeight: "600",
                                          }}
                                          className={
                                            toggleStates[
                                              index + indexOfFirstItem
                                            ] === false
                                              ? "red-text"
                                              : "grey-text"
                                          }
                                        >
                                          Inactive
                                        </p>
                                      </div>
                                    }
                                    <div className="col-2 dial_div">
                                      <FormControlLabel
                                        style={{ marginTop: "-10px" }}
                                        control={
                                          <Android12Switch
                                            defaultChecked={
                                              toggleStates[
                                                index + indexOfFirstItem
                                              ]
                                            }
                                            onChange={() =>
                                              handleToggle(
                                                index + indexOfFirstItem,
                                                userData.tra_id
                                              )
                                            }
                                          />
                                        }
                                      />
                                    </div>
                                    <div className="col-5 second_status">
                                      <p
                                        className={
                                          toggleStates[
                                            index + indexOfFirstItem
                                          ] === true
                                            ? "green-text"
                                            : "grey-text"
                                        }
                                      >
                                        Active
                                      </p>
                                    </div>
                                  </div>
                                </td> */}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <div
                        className="footer card-footer"
                        style={{ marginTop: "12px" }}
                      >
                        <div className="row">
                          {
                            <div className="result_msg_text col-lg-7 col-sm-7 sol-12">
                              Displaying {rangeEnd} results of {totalItems}
                            </div>
                          }
                          <div className="button_module col-12 col-lg-5 col-sm-5 col-md-5 d-flex ">
                            {/* <div className="title" style={{ marginRight: "16px" }}>
                    Page
                  </div> */}
                            <div
                              className="dropdown d-flex"
                              style={{
                                alignItems: "center",
                                marginRight: "10px",
                              }}
                            >
                              <p className="paginate_msg_text">Page</p>
                              <select
                                value={currentPage}
                                onChange={(e) =>
                                  setCurrentPage(Number(e.target.value))
                                }
                                className="select_page"
                                style={{
                                  marginRight: "8px",
                                  marginLeft: "16px",
                                }}
                              >
                                {Array.from({ length: totalPages }, (_, i) => (
                                  <option key={i + 1} value={i + 1}>
                                    {i + 1}
                                  </option>
                                ))}
                              </select>
                              <span className="paginate_msg_text">
                                of {totalPages}
                              </span>
                            </div>
                            <div className="d-flex">
                              <button
                                type="button"
                                className="bton"
                                onClick={prevPage}
                                disabled={currentPage === 1}
                              >
                                <img
                                  src={prevArrow}
                                  alt="prev"
                                  className="arrow_btn"
                                />
                              </button>

                              <button
                                type="button"
                                className="bton"
                                onClick={nextPage}
                                disabled={currentPage === totalPages}
                              >
                                <img
                                  src={nextArrow}
                                  alt="next"
                                  className="arrow_btn"
                                />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </section>
          {/* modal */}
          <section className="AddPrincipal-section">
            <div
              className="modal fade"
              id="exampleModal"
              tabindex="-1"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">
                      Add Diet
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      onClick={handleCancel}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <form id="dietForm" onSubmit={handleFormSubmit}>
                      <div className="mb-3">
                        <label for="dietName" className="form-label">
                          Diet Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="dietName"
                          name="name"
                          value={newDiet.name}
                          onChange={handleChange}
                        />
                        {errors.name && (
                          <div className="text-danger">{errors.name}</div>
                        )}
                      </div>
                      <div className="mb-3">
                        <label for="dietPhone" className="form-label">
                          Diet Phone
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="dietPhone"
                          name="phone"
                          value={newDiet.phone}
                          onChange={handleChange}
                        />
                        {errors.phone && (
                          <div className="text-danger">{errors.phone}</div>
                        )}
                      </div>
                      <div className="mb-3">
                        <label htmlFor="dietEmail" className="form-label">
                          Diet Email
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          id="dietEmail"
                          name="email"
                          value={newDiet.email}
                          onChange={handleChange}
                        />
                        {errors.email && (
                          <div className="text-danger">{errors.email}</div>
                        )}
                      </div>
                      {/* <div class="mb-3">
                        <label for="schoolName" class="form-label">
                          School Name
                        </label>
               
                        <Select
                          isMulti
                          name="schoolName"
                          options={schoolOptions}
                          value={schoolOptions.filter((option) =>
                            newPrincipal.schoolIds.includes(option.value)
                          )}
                          onChange={handleSchoolChange}
                          placeholder="Search for a school"
                        />

                      </div> */}
                    </form>
                  </div>
                  <div class="modal-footer d-flex justify-content-center">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                      onClick={handleCancel}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      form="dietForm"
                      className="btn btn-primary"
                      onClick={handleFormSubmit}
                    >
                      Add
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </>
  );
};

export default Diet;
